<template>
  <div>
    <div class="game-item-operate">
      <span @click="doOperate(gameInfo, 'recharge')">充值</span>
      <span @click="doOperate(gameInfo, 'download')">下载</span>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  
  components: {
    
  },
  props: {
    gameInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
  },
  methods: {
    doOperate(info, flag) {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }
      this.$emit("doOperate", info, flag);
    },
  },
};
</script>

<style lang="scss">
.game-item-operate {
  span {
    display: block;
    width: 105px;
    height: 50px;
    border-radius: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    line-height: 50px;
    text-align: center;

    &:first-child {
      color: #ffffff;
      background: #ff7a3e;
      margin-bottom: 23px;
    }
    &:last-child {
      border: 2px solid #ff7a3e;
      color: #ff7a3e;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/OperateBtns.vue